import React from 'react';
import { Segment, Button, Grid, Image, Loader } from 'semantic-ui-react'

import InpatientClaimsHorImage from './inpatient_claims_hor.png';
import OutpatientClaimsHorImage from './outpatient_claims_hor.png';

const ClaimSubmissionSelector = ({updateTypeSelector, claimOptions, configBenefit}) => {
    if(configBenefit && claimOptions && (claimOptions.inpatientClaimOptions || claimOptions.outpatientClaimOptions) ) {
        return (
            <Grid.Row>
                <Grid.Column>
                    <p>
                        Please indicate claim type submission
                    </p>
                    <Segment padded>
                        <Button.Group widths='2' basic>
                            <Button
                                onClick={() => updateTypeSelector('outpatient')}
                            >
                                <Image src={OutpatientClaimsHorImage} fluid/>
                            </Button>
                            <Button
                                onClick={() => updateTypeSelector('inpatient')}
                            >
                                <Image src={InpatientClaimsHorImage} fluid/>
                            </Button>
                        </Button.Group>
                    </Segment>
                </Grid.Column>
            </Grid.Row>
        );
    }
        
    return <Loader active />;
}    

export default ClaimSubmissionSelector;

/*
<Button.Group widths='3' basic>
    <Button
        onClick={() => updateTypeSelector('flex')}
        disabled={true}
    >
        <Image src="/flexible_claims.png" fluid/>
    </Button>
    <Button
        onClick={() => updateTypeSelector('outpatient')}
    >
        <Image src="/outpatient_claims.png" fluid/>
    </Button>
    <Button
        onClick={() => updateTypeSelector('inpatient')}
    >
        <Image src="/inpatient_claims.png" fluid/>
    </Button>
</Button.Group>
*/